import { BASE_URI } from "~/assets/base";
import instanceAxios from "./axios.instance";

export const getTerminalWithStoreId = async (storeId) => {
  const res = await instanceAxios.get(`${BASE_URI}terminals/${storeId}`);
  return res.data;
};

export const createTerminal = async (storeId) => {
  const res = await instanceAxios.post(`${BASE_URI}terminal/add`, { storeId });
  return res.data;
};

export const updateTerminalStatus = async (terminalId, status) => {
  const res = await instanceAxios.put(
    `${BASE_URI}terminal/status/${terminalId}`,
    {
      enable: status,
    }
  );
  return res.data;
};

export const updateTerminal = async (storeId, data) => {
  const res = await instanceAxios.put(`${BASE_URI}terminal/${storeId}`, data);
  return res;
};

export const getTerminalByStoreId = async (storeId) => {
  const res = await instanceAxios.get(`${BASE_URI}terminal/${storeId}`);
  return res.data;
};
